/* unplugin-vue-components disabled */import script from "./CarbonFriend.vue?vue&type=script&setup=true&lang=js"
export * from "./CarbonFriend.vue?vue&type=script&setup=true&lang=js"

import "./CarbonFriend.vue?vue&type=style&index=0&id=2a93c394&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a93c394"]])

export default __exports__